export default {
  priv: 'pr_device',
  overviewTitle: 'Layout Certificaten',
  detailTitle: 'Layout Certificaat',
  deleteTitle: 'deze layout',
  url: '/devices/certificatelayouts',
  apiUrl: '/devicecertificatelayouts/',
  sortBy: ['name'],
  sortDesc: [false],
  deletable: true,
  editable: true,
  filterName: 'certificatelayouts',
  quickFilter: {
    text: 'Zoek op naam',
    value: 'name',
    type: 'str'
  },
  tableFields: [
    {
      text: 'Naam',
      value: 'name',
      link: '/devices/certificatelayouts/{id}',
      width: '30%'
    },
    {
      text: 'Bestandsnaam',
      value: 'file.name',
      width: '30%'
    },
    {
      text: 'Grootte',
      value: 'file.size',
      width: '12.5%',
      filter: 'prettyBytes'
    },
    {
      text: 'Bestand',
      value: 'file',
      width: '5%',
      type: 'file',
      align: 'center',
      sortable: false
    },
    {
      text: 'Laatste aanpassing',
      value: 'modified_timestamp',
      width: '15%',
      align: 'center',
      filter: 'timestamp'
    }
  ]
};
